export class UserProfile {
  public userId?: string;
  public username?: string;
  public firstName?: string;
  public lastName?: string;
  public email?: string;
  public commissionCode?: number;
  public companyCode?: string;
  public branchPlant?: string;
  public sbuCode?: string;
  public accountNumber?: number;
  public role?: string;
  public initials?: string;
  public isEmployee: boolean = false;
  public includeProformas?: boolean = false;
  public isSalesRep: boolean = false;
  public isDealer: boolean = false;

  constructor(
    userId?: string,
    username?: string,
    firstName?: string,
    lastName?: string,
    email?: string,
    commissionCode?: number,
    companyCode?: string,
    branchPlant?: string,
    sbuCode?: string,
    accountNumber?: number,
    role?: string,
    initials?: string,
    includeProformas?: boolean
  ) {
    this.userId = userId;
    this.username = username;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.commissionCode = commissionCode;
    this.companyCode = companyCode;
    this.branchPlant = branchPlant;
    this.sbuCode = sbuCode;
    this.accountNumber = accountNumber;
    this.role = role;
    this.initials = initials;
    this.includeProformas = includeProformas;
  }
}
